import { APITransport } from '@client/transports/api';

export const GroupsService = {
  async createGroup(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/sendergroups',
      body
    });
  },

  async deleteGroup(body = {}) {
    return APITransport.post({
      path: '/rest/domain/delete/sendergroups',
      body
    });
  },

  async getAll() {
    const response = await APITransport.get({
      path: '/rest/domain/sendergroups'
    });

    return Array.isArray(response) ? response : [];
  },

  async getGroupById(query) {
    const groups = await GroupsService.getAll();
    return groups.find(({ groupname }) => groupname === query);
  },

  async getDynamicMembers(body) {
    return APITransport.post({
      path: '/rest/domain/execute/dynamicmembers',
      body
    });
  },

  async findGroupByEmail(body) {
    return APITransport.post({
      path: '/rest/domain/execute/finddepartments',
      body
    });
  },

  async getGoogleGroups(body = {}) {
    return APITransport.post({
      path: '/rest/domain/execute/getgappsgroups',
      body
    });
  },

  async getGoogleCountries(body = {}) {
    return APITransport.post({
      path: '/rest/domain/execute/getgappscountries',
      body
    });
  },

  async getGoogleOrgs(body = {}) {
    return APITransport.post({
      path: '/rest/domain/execute/getgappsorganizations',
      body
    });
  },

  async getOfficeGroups(body = {}) {
    return APITransport.post({
      path: '/rest/domain/execute/geto365groups',
      body
    });
  },

  async getOktaGroups(body = {}) {
    return APITransport.post({
      path: '/rest/domain/execute/getoktagroups',
      body
    });
  },

  async getSenders(query) {
    return APITransport.get({
      path: '/rest/listofvalues/listsenders',
      query
    });
  },

  async getSenderGroups(query) {
    return APITransport.get({
      path: '/rest/listofvalues/listsendergroups',
      query
    });
  },

  async getWorkdayManagers(body) {
    return APITransport.post({
      path: '/rest/domain/execute/getcsvtreenodes',
      body
    });
  },

  async updateGroup(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/sendergroups',
      body
    });
  }
};
